/**
 * @file
 * @fileOverview This file contains the OnlineAudioStreamer class for streaming audio from an online source.
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

import { Howl, Howler } from 'howler';

class OnlineAudioStreamer {
  constructor(url, volume = 0.5, formats = ['mp3', 'aac']) {
    this.url = url;
    this.radio = null;
    this.volume = volume;
    this.formats = formats;
  }

  init() {
    this.radio = new Howl({
      src: [this.url],
      html5: true,
      format: formats,
      preload: true,
      autoplay: false,
      volume: volume,
    });
  }

  detectType(variable) {
    if (typeof variable === 'string') {
      return 'string';
    } else if (Array.isArray(variable)) {
      return 'array';
    } else {
      return 'unknown';
    }
  }

  play() {
    this.radio.play();
  }

  stop() {
    this.radio.stop();
  }

  pause() {
    this.radio.pause();
  }

  getVolume() {
    return this.radio.volume();
  }

  setVolume(volume) {
    this.radio.volume(volume);
    this.volume = volume;
  }

  mute() {
    this.radio.mute(true);
  }

  unmute() {
    this.radio.mute(false);
  }

  setAudioUrl(url) {
    if (this.radio != null) {
      this.radio.stop();
    }
    this.radio = new Howl({
      src: [url],
      html5: true,
      format: this.formats,
      preload: true,
      autoplay: false,
      volume: this.volume,
    });

    this.url = url;
    this.radio.play();
  }
}

export default OnlineAudioStreamer;
